export const USER_PREF_PREFIX = 'pref';
export const LAST_ACTIVE_PROJECT_ID = 'last_active_project_id';
export const VISIBLE_LAYER_IDS_PREFKEY = 'visible_layer_ids';
export const EXPLORE_MAP_VIEWPORT = 'explore_map_viewport';
export const USER_FLOW_PREFIX = 'flow';

export function makeUserDataKey(userKey: string, key: string) {
  return `${userKey}:${key}`;
}
